import { render } from "./shopMoney.vue?vue&type=template&id=5354b590&scoped=true"
import script from "./shopMoney.vue?vue&type=script&lang=js"
export * from "./shopMoney.vue?vue&type=script&lang=js"

import "./shopMoney.vue?vue&type=style&index=0&id=5354b590&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5354b590"]])

export default __exports__